import ResourceManager from "../../components/ResourceManager"
import { StringMap } from "i18next"
import { useI18n } from "../../hooks"
import { useOptions } from "../../options/hooks/use-options"
import { useProjectMutations } from "../hooks/use-project-mutations"
import { ProjectViewModel } from "../api/project"

const ProjectSuppliersWidget = ({ project }: { project: ProjectViewModel }) => {
  const translations = useTranslations(defaultTranslations)
  const { supplierOptions } = useOptions(project.maintainerId)
  const { addSuppliers, removeSuppliers } = useProjectMutations()

  if (!project) return null
  const handleAddSuppliers = (ids: string[]) => {
    const suppliers = supplierOptions
      .filter((supplier) => ids.includes(supplier.id))
      .map((supplier) => ({ name: supplier.name, id: supplier.id }))

    return addSuppliers(project.id, suppliers)
  }

  const handleRemoveSupplier = (id: string) => {
    const suppliers = project.suppliers
      .filter((supplier) => supplier.id === id)
      .map((supplier) => ({ name: supplier.name, id: supplier.id }))
    return removeSuppliers(project.id, suppliers)
  }
  const sortedSupplierOptions = supplierOptions
    .slice()
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
  const sortedSuppliers = project.suppliers
    .slice()
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

  return (
    <ResourceManager
      title={translations.title}
      resourceOptions={sortedSupplierOptions}
      resources={sortedSuppliers}
      canAddResource={project.canUpdateSuppliers}
      canRemoveResource={project.canUpdateSuppliers}
      onAddResources={handleAddSuppliers}
      onRemoveResource={handleRemoveSupplier}
      emptyOptionsMessage={translations.emptyOptionsMessage}
      emptyResourcesMessage={translations.emptyResourcesMessage}
      isMultipleSelection
    />
  )
}

const useTranslations = (defaults = defaultTranslations): Translations => {
  const { translations: t } = useI18n("project")
  const translations = (t?.suppliersWidget || {}) as StringMap

  const {
    title = defaults.title,
    emptyOptionsMessage = defaults.emptyOptionsMessage,
    emptyResourcesMessage = defaults.emptyResourcesMessage,
  } = translations

  return {
    title,
    emptyOptionsMessage,
    emptyResourcesMessage,
  }
}

const defaultTranslations = {
  title: "Suppliers",
  emptyOptionsMessage: "No suppliers in this organisation",
  emptyResourcesMessage: "No suppliers in this project",
}

type Translations = typeof defaultTranslations

export default ProjectSuppliersWidget
